<ion-grid class="ion-no-padding">
  <ion-row class="ion-align-items-center ion-justify-content-center">
    <ion-col size="12" size-md="auto">
      <ion-text color="dark">
        <h3 class="cta-text">{{ node?.cta_text }}</h3>
      </ion-text>
    </ion-col>
    <ion-col size="12" size-md="auto">
      <app-button
        [icon]="{ name: 'arrow-right', position: 'right' }" 
        [href]="node?.hyperlink"
        [target]="node?.target ? node?.target : '_self'">
        {{ node?.button_text }}
      </app-button>
    </ion-col>
  </ion-row>
</ion-grid>
